<template>

  <svg
    t="1632727424313"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6613"
    width="64"
    height="64"
  ><path d="M879.672 174.848v-0.005c-99.92-99.915-259.546-107.054-368.203-20.817-108.612-86.994-268.826-79.865-369.509 20.822C37.479 279.325 38.508 457.344 143.524 567.4c1.405 1.845 3.072 3.671 5.026 5.457a43.439 43.439 0 0 0 2.266 1.929L511.677 934.49l370.305-370.429c105.392-107.949 104.358-282.55-2.31-389.213z" p-id="6614" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconShapeHeart',
} as DefineComponent
</script>